
import React, { PureComponent } from 'react';
class HeroTextOne extends PureComponent {
  render() {
    return (
      <span>Congrats on your path to discovering if your girlfriend is a
      </span>
    );
  }
}

export default HeroTextOne;